module.exports = __webpack_public_path__ + "static/img/23_daqiyali.c9e12468.png";